import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { resolveGraphFrontendComponentAllowlist, } from '@super/shared-types';
const GraphFrontendComponentAllowlistCtx = createContext(null);
export function GraphFrontendComponentAllowlistProvider({ context, children, }) {
    const allowlist = useMemo(() => resolveGraphFrontendComponentAllowlist(context), [context]);
    return (_jsx(GraphFrontendComponentAllowlistCtx.Provider, { value: allowlist, children: children }));
}
export function useGraphFrontendComponentAllowlist() {
    const value = useContext(GraphFrontendComponentAllowlistCtx);
    if (!value) {
        throw new Error('useGraphFrontendComponentAllowlist must be used within a GraphFrontendComponentAllowlistProvider');
    }
    return value;
}
//# sourceMappingURL=GraphFrontendComponentAllowlistContext.js.map